import styled from "styled-components/macro";

import { calculateRem, calculateRems } from "styles/mixins/calculateRem";

export const StyledContainer = styled.div`
  max-width: 70rem;
  text-align: center;
`;

export const StyledImage = styled.img`
  margin: ${calculateRems([42, 0, 24, 0])};
  max-width: ${calculateRem(249)};
`;
